import {createSvgIcon} from '../create-svg-icon';

export const ArrowForwardIcon = createSvgIcon(
  <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
, 'ArrowForwardOutlined');
